export class RestrictionViewModel {
    public attributeTypeId: number;
    public code: string;
    public displayValue: string;
    public source: string;
    public attributeCategory: string;
    public updatedBy: string;
    public updatedDate: Date;
    public attributeAccessTypeId: number;
    public endDate: Date;
    public id: number;
}
